import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { PartyPopper, X } from "lucide-react";

export const LAUNCH_DATE = "July 19, 2026";
export const SALE_END = "2026-08-02T23:59:59";

export function CountdownTimer({ target }) {
  const end = target ? (typeof target === "number" ? target : new Date(target).getTime()) : new Date(SALE_END).getTime();
  const calc = () => Math.max(0, end - Date.now());
  const [ms, setMs] = useState(calc());
  useEffect(() => {
    const t = setInterval(() => setMs(calc()), 1000);
    return () => clearInterval(t);
  }, [end]);
  if (ms <= 0) return null;
  const s = Math.floor(ms / 1000);
  const parts = [
    [Math.floor(s / 86400), "days"],
    [Math.floor((s % 86400) / 3600), "hrs"],
    [Math.floor((s % 3600) / 60), "min"],
    [s % 60, "sec"],
  ];
  return (
    <div data-testid="sale-countdown" className="inline-flex items-center gap-3 rounded-2xl bg-white/5 border border-white/10 px-6 py-3">
      {parts.map(([v, l], i) => (
        <React.Fragment key={l}>
          {i > 0 && <span className="text-slate-600 text-2xl font-black -mt-1">:</span>}
          <div className="flex flex-col items-center min-w-[42px]">
            <span className="text-2xl sm:text-3xl font-black text-white tabular-nums">{String(v).padStart(2, "0")}</span>
            <span className="text-[10px] uppercase tracking-wider text-slate-400">{l}</span>
          </div>
        </React.Fragment>
      ))}
    </div>
  );
}

export default function LaunchBanner() {
  const [open, setOpen] = useState(true);
  if (!open) return null;
  return (
    <div data-testid="launch-banner" className="relative z-40 bg-gradient-to-r from-violet-600 via-fuchsia-600 to-emerald-500 text-white">
      <div className="max-w-7xl mx-auto px-10 py-2.5 flex items-center justify-center gap-2 text-center text-sm font-semibold">
        <PartyPopper className="w-4 h-4 shrink-0" />
        <span>
          We're officially <span className="font-black">LIVE</span> as of {LAUNCH_DATE}! Grand-launch sale on all Core Credits, {" "}
          <Link to="/pricing" className="underline underline-offset-2 hover:opacity-90" data-testid="launch-banner-cta">grab the deal</Link>. Grow with us!
        </span>
        <button data-testid="launch-banner-close" onClick={() => setOpen(false)} className="absolute right-3 top-1/2 -translate-y-1/2 opacity-80 hover:opacity-100"><X className="w-4 h-4" /></button>
      </div>
    </div>
  );
}
